// extracted by mini-css-extract-plugin
module.exports = {"buttonsUpdate":"EditableSliceWrapper_buttonsUpdate__hfQfJ"};